<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qhu5p8/tc-custom/9783962725495.jpg?1703042359901" alt="This image is the cover for the book Jaunty Jock, and other Stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jaunty Jock, and other Stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "The last of the West Bow balls before Lady Charlotte ran away with her dancing-master was on a dirty evening in November.  Edinburgh was all day wrapped in haar, and now came rain that made the gutters run like mountain burns and overflow into the closes, to fall in shallow cataracts to the plain below.  There was a lively trade in the taverns.  “Lord! there’s a sneezer for ye!” said the customers ordering in their ale, not really minding the weather much, for it was usual and gave a good excuse for more assiduous scourging of the nine-gallon tree; p. 4but their wives, spanging awkwardly on pattens through the mud on their way to the fishwife at the Luckenbooths for the supper haddocks, had such a breeze in their petticoats and plaids they were in a terror that they should be blown away upon the blasts that came up the gulleys between the towering “lands,” and daring slates and chimney-pots, and the hazards of emptied vessels from the flats above, kept close to the wall as luggers scrape the shore of Fife when the gale’s nor’-west."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil Munro
      </h2>
      
      <p class="authorDescription body article">Neil Munro (3 June 1863 – 22 December 1930) was a Scottish journalist, newspaper editor, author and literary critic. He was basically a serious writer, but is now mainly known for his humorous short stories, originally written under the pen name Hugh Foulis. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB-ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6b02d30